import React from 'react'
import { Input } from 'antd'
import Button from 'components/Button'
import styled from 'styled-components'
const { Search } = Input

const StyledSearch = styled(Search)`
  width: 150px;
  ${''}
  margin: 15px;
  border-radius: 10px;

  &::placeholder {
    font-size: 6px;
  }
  .ant-btn.ant-btn-primary.ant-btn-lg.ant-input-search-button {
    background: #e3e3e3;
    border: 1px solid #e5e5e5;
    color: #6f6f6f;
    font-weight: 500;
    border-radius: 5px;
  }
  .ant-btn.ant-btn-primary.ant-btn-lg.ant-input-search-button span {
    font-size: 0.8rem;
  }
`
const Container = styled.div`
  display: flex;

  flex-direction: row;
  justifycontent: spaceBetween;
  margin: 15px;
  align-items: baseline;
`
const Text = styled.div`
  display: flex;
  flex-direction: row;
  justifycontent: spaceBetween;
`

const SelectionText = styled.div`
  font-size: 12px;
  display: flex;
  flex-direction: column;
`
const RowButtons = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 10px;
`
const SecondaryButton = styled(Button.Secondary)`
  border: 1px solid #ccc;
  border-radius: 20px;
  padding: 5px 16px;
  margin: 4px;
  height: max-content;
  & div > div {
    font-weight: 500;
    font-size: 0.8rem;
  }

  &:hover {
    border-color: rgba(50, 73, 215, 1);
    color: black;
  }
`
const CTCRangeFilter = ({
  handleFromSearch,
  handleToSearch,
  fromSearch,
  toSearch,
  quickActivebtn,
  handleQuickButtonClick,
  QuickSelection,
}) => {
  return (
    <>
      <Container style={{ margin: '10px 0px' }}>
        <Text>From</Text>
        <StyledSearch
          placeholder="Enter Amount"
          allowClear
          enterButton="LPA"
          size="large"
          value={
            fromSearch ? parseInt(fromSearch, 10).toLocaleString('en-IN') : ''
          }
          onChange={e => {
            const inputValue = e.target.value.replace(/,/g, '')
            if ((/^\d*$/.test(inputValue) && inputValue.length <= 7) || inputValue === '') {
              handleFromSearch(inputValue)
            }
          }}
          
        />
        <Text>To</Text>
        <StyledSearch
          placeholder="Enter Amount"
          allowClear
          enterButton="LPA"
          size="large"
          value={toSearch ? parseInt(toSearch, 10).toLocaleString('en-IN') : ''}
          onChange={e => {
            const inputValue = e.target.value.replace(/,/g, '')
            if ((/^\d*$/.test(inputValue) && inputValue.length <= 7) || inputValue === '') {
              handleToSearch(inputValue)
            }
          }}
          
        />
      </Container>
      <SelectionText>Quick Selection</SelectionText>

      <RowButtons>
        {QuickSelection.map((item, index) => {
          return (
            <SecondaryButton
              text={item.value}
              style={{
                backgroundColor:
                  quickActivebtn[0] === item.value
                    ? 'rgb(50, 73, 215)'
                    : 'transparent',
                color:
                  fromSearch !== '' || toSearch !== ''
                    ? 'rgb(182 180 180)'
                    : quickActivebtn[0] === item.value
                    ? '#fff'
                    : '#000',
              }}
              disabled={fromSearch !== '' || toSearch !== ''}
              active={quickActivebtn === item}
              onClick={() => handleQuickButtonClick([item.value])}
            ></SecondaryButton>
          )
        })}
      </RowButtons>
    </>
  )
}

export default CTCRangeFilter
